<template>
    <div class="container px-2 px-lg-4">
        <BaseHeader :title="title">
            <router-link v-if="globalStore.hasPermissionTo('new_product')" to="/products/create" class="item action btn-group">
                <BaseButton  class="btn btn-success w-100"> Novo</BaseButton>
            </router-link>
        </BaseHeader>
        <BaseFilter :title="title" @search="search" :initialSearch="initialSearch">
            <div class="item action">
                <BaseButton class="btn-filter btn-success w-100" data-bs-toggle="dropdown" ariahashpopup="true" aria-expanded="true" data-bs-auto-close="outside">
                    <font-awesome-icon icon="far fa-filter" />
                    Filtros
                    <span class="filters_qty_active">{{ totalFilters }}</span>
                </BaseButton>
                <div v-if="isLoadingFilters != true" class="dropdown-menu dropdown-menu-end py-0"  aria-labelledby="dropdownMenu">
                    <ProductsFilters @filters="filters" :initialFilters="initialFilters" @filtersQty="filtersQty" />
                </div>
            </div>
        </BaseFilter>
        <BaseTable class="no_top_radius" :columns="tableColumns" :paginate="paginate" :isLoading="isLoading" :qty="products.length" @changePage="changePage">
            <tr v-for="(product, key) in products" :key="key">
                <td width="10">{{ product.id }}</td>
                <td>
                    <div class="d-flex align-items-center">
                        <div class="product_image" :style="'background: url(' + product.image + ');'"></div>
                        {{product.title }}
                        <BaseBadget v-if="product.tag" small class="ms-1" color="#424242" :text="product.tag" />
                    </div>
                </td>
                <td><div class="sensitive_information">{{ product.status_name }}</div></td>
                <td><div class="sensitive_information">{{ globalStore.formatMoney(product.price) }}</div></td>
                <td v-if="globalStore.storesList.length > 1"><BaseStoreDot :color="product.store.color" :title="product.store.title"/></td>
                <td v-else></td>
                <td class="actions">
                    <span v-if="product.status !== 'draft' && product.status !== 'disabled'" @click="copy(product.url)" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-animation="true" v-tooltip :title="tooltipText"><font-awesome-icon icon="fa-regular fa-link" /></span>
                    <router-link :to="'/products/' + product.id" v-if="globalStore.hasPermissionTo('edit_product')" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-animation="true" v-tooltip title="Editar"><font-awesome-icon icon="fas fa-edit" /></router-link>
                    <span v-if="globalStore.hasPermissionTo('duplicate_product') || globalStore.hasPermissionTo('destroy_product')" class="dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true"><font-awesome-icon icon="fas fa-ellipsis-h" /></span>
                    <div class="dropdown-menu" x-placement="bottom-start" aria-labelledby="dropdownMenu">
                        <span v-if="globalStore.hasPermissionTo('duplicate_product')" class="dropdown-item d-flex justify-content-center flex-column" @click="duplicateProduct(product.id)">Duplicar</span>
                        <span v-if="globalStore.hasPermissionTo('destroy_product')" class="dropdown-item d-flex justify-content-center flex-column" @click="openPopup(product.id)">Remover</span>
                    </div>
                </td>
            </tr>
        </BaseTable>
        <router-view></router-view>
            <BasePopup v-if="confirmAction" closeType="stayOnPage" width="400" @clickToClose="clickToClose">
                <div class="confirm_action">
                    <div class="popup ">
                        <p class="title">Atenção</p>
                        <p class="text">Deseja remover esse produto?</p>
                        <h6>Escreva a palavra "EXCLUIR" para confirmar.</h6>
                        <BaseInput
                            label=''
                            type="text"
                            id="excludeTextConfirm"
                            v-model="excludeTextConfirm"
                            :page="route.name"
                            class="col-12 mb-3"
                        />
                        <baseButton @click="clickToClose" style="width:110px" class="btn-secondary me-2">Cancelar</baseButton>
                        <baseButton @click="deleteProduct" style="width:150px" class="btn-success ms-2" :disabled="excludeTextConfirm == 'EXCLUIR' || excludeTextConfirm == 'excluir'  ? false : true">Sim, remover</baseButton>
                    </div>
                </div> 
            </BasePopup>
    </div>
</template>
<script setup>
const title = { title: "Produtos", icon: "fa-box" };
import { ref, onBeforeMount, shallowRef, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from 'pinia'
import { useProductStore } from '@/stores/products';
import { useGlobalStore } from '@/stores/global';
import ProductsFilters from '@/components/includes/products/ProductsFilter'
import BaseFilter from '@/components/ui/BaseFilter';

const productStore = useProductStore();
const { products, paginate } = storeToRefs(productStore);

const globalStore = useGlobalStore();
const { defaultStore } = storeToRefs(globalStore);


const route = useRoute();
const router = useRouter();

const isLoading = ref(false);
const isLoadingFilters = ref(true);

let initialFilters = null;
let initialSearch = null;

onBeforeMount(() => {
    if(!globalStore.hasPermissionTo('products')) {
        return router.push('/403');
    }

    let checkTotalProd = Number.isInteger(productStore.total_productor);
    let checkTotalCoprod = Number.isInteger(productStore.total_coproductor);
    let checkTotalRef = Number.isInteger(productStore.total_referral);

    if(checkTotalProd && checkTotalCoprod && checkTotalRef){
        let r = document.querySelector(':root');
        r.style.setProperty('--loaderFontSize', '15px')
    } 
    
    if(route.query.search || route.query.tags || route.query.status) {
            Object.keys(productStore.filters_products).forEach((key) => {
            let param = route.query[key];
            productStore.filters_products[key] = (param == undefined) ? null : param;

            if(key == 'tags') {
                if((productStore.filters_products[key]) && productStore.filters_products[key].constructor !== Array) {
                    let currentThing = productStore.filters_products[key];
                    productStore.filters_products[key] = [];
                    productStore.filters_products[key].push(currentThing);
                    }
            } else if(key == 'status'){
                if((productStore.filters_products[key]) && productStore.filters_products[key].constructor !== Array) {
                    let currentThing = productStore.filters_products[key];
                    productStore.filters_products[key] = '';
                    productStore.filters_products[key] = currentThing;
                }
            }
        })
        initialFilters = productStore.filters_products; 
        isLoadingFilters.value = false
        router.replace({query: initialFilters});
        initialSearch = initialFilters.search;
    } else {
        initialFilters = productStore.filters_products;
        isLoadingFilters.value = false
        initialSearch = initialFilters.search;
    }

        let usedParams = {};

    if(productStore.filters_products){
        router.replace({query: productStore.filters_products})
        Object.keys(productStore.filters_products).forEach((key) => {
            if(productStore.filters_products[key] != null && productStore.filters_products[key] != '') {
                let currentParams = {
                    ...usedParams,
                    [key]: productStore.filters_products[key]
                };
                usedParams = currentParams;
            }
        });
        router.replace({query: usedParams})
    }

    if(productStore.products.length == undefined || router.options.history.state.replaced === true){
        isLoading.value = true;
    }

    loadProducts();
     
})

function search(r) {
    productStore.filters_products.search = r;
    loadProducts();
}

function filters(r) {
    Object.keys(r).forEach((key) => {
        productStore.filters_products[key] = r[key];
    });
    globalStore.loader('show');
    loadProducts();
}

const totalFilters = ref(0);

function filtersQty(r) {
    totalFilters.value = r;
}

const tableColumns = ['ID', 'Nome', 'Status', 'Valor', globalStore.storesList.length > 1 ? 'Loja' : null];

const params = ref({
    'search': null,
    'page': null,
    'status': ' ',
    'tags': null,
});

const confirmAction = shallowRef(null);
const excludeTextConfirm = ref(null)

const emit = defineEmits(["removeLoading"]);

async function loadProducts() {
    let usedParams = {};

    Object.keys(productStore.filters_products).forEach((key) => {
        if(productStore.filters_products[key] != null) {
            let currentParams = {
                ...usedParams,
                [key]: productStore.filters_products[key]
            };
            usedParams = currentParams;
            router.replace({query: usedParams});
        }
    });


    
    await productStore.tryProducts(usedParams).then(function (success){
        if(success){
            isLoading.value = false;
            emit('removeLoading')
            globalStore.loader('hide');
        }
    })
}

let isChangingPage = false;
async function changePage(p) {
    if(isChangingPage) return;
    productStore.filters_products.page = p;

    Object.keys(productStore.filters_products).forEach((key) => {

        if(key == 'tags'){
            productStore.filters_products[key] = route.query['tags']
        } else if(key == 'status'){
            productStore.filters_products[key] = route.query['status']
        }
    });

    globalStore.loader('show');
    isChangingPage = true;
    loadProducts(false).then(() => {
        isChangingPage = false;
        window.scrollTo({ top:0, left:0, behavior: "instant"});
    });
}

let loadDefaultStore = false;
watch(defaultStore, function () {
    if(!loadDefaultStore) {
        loadDefaultStore = true;
        if(route.query.status === undefined){
            productStore.filters_products.status = null;
        } else {
            route.query.status
        }

        productStore.filters_products.page = null;
        loadProducts(params).then(()=> {
            globalStore.loader('hide');
            loadDefaultStore = false;
        });
    }
});

let isDeleting = false;
let productToDelete = null;
async function deleteProduct() {
    if(!isDeleting && productToDelete && excludeTextConfirm.value == 'EXCLUIR' || excludeTextConfirm.value == 'excluir') {
        isDeleting = true;
        globalStore.loader('show');
        await productStore.tryDeleteProduct(productToDelete).then(() =>{
            productStore.tryProducts(productStore.filters_products).then(() =>{
                router.replace({query: productStore.filters_products});
                globalStore.loader('hide');
                isDeleting = false;
                confirmAction.value = null;
                excludeTextConfirm.value = null;
            })
        })
    }
}

async function duplicateProduct(product_id){
    globalStore.loader('show');
    isLoading.value = true
    productStore.tryDuplicateProduct(product_id).then(function(id_duplicated_product) {
        globalStore.cleanObject(productStore.product);
        router.push('/products/' + id_duplicated_product)
        globalStore.loader('hide');
    })
}

var tooltipText = "Copiar Link"

function copy(url) {
    
    const tooltipInner = document.querySelector('.tooltip-inner')
    tooltipInner.innerHTML = 'Link copiado'
    
    var copyText = url;
    navigator.clipboard.writeText(copyText);
}

function openPopup(product) {
    productToDelete = product
    confirmAction.value = true;
    excludeTextConfirm.value = null;
}

function clickToClose() {
    confirmAction.value = null;
}


</script>

<style scoped>

a {
    text-decoration: none;
    color: inherit !important;
}

.active {
    background-color: #ececec;
}

.box_content_load :deep(.info_value){
    width: 100%;
    border-radius: 3px;
    height: 6px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */
    background: linear-gradient(to right, #f6f7f9 0%, #e9ebee 20%, #f6f7f9 100%);
    font-size: var(--loaderFontSize);
    background-size: 800px 21px;
    animation: loading 1s linear infinite forwards;
}

.filters_qty_active{
    background-color: #7ad563;
    padding: 0px 6px;
    font-size: 12px;
    color: white;
    border-radius: 40px;
    margin-left: 9px;
}
</style>